<div class="pb-2">
  <input type="checkbox" [class.k-state-invalid]="showError" [formControl]="formControl" [formlyAttributes]="field"
    kendoCheckBox />
  <label [for]="id" class="k-checkbox-label">
    <span>
      {{ to.label }}
      <span *ngIf="to.required && to.hideRequiredMarker !== true" class="k-required">*</span>
    </span>
  </label>
  <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>